export default class ContractItemExchangeCurrency {
  id: string;

  name: string;

  symbol: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.symbol = obj.symbol || '';
  }

  public static of(obj: any): ContractItemExchangeCurrency {
    return new ContractItemExchangeCurrency(obj || {});
  }

  public static ofList(obj: any[]): ContractItemExchangeCurrency[] {
    return obj.map(this.of);
  }
}
